import * as React from "react";
import { useMutation } from "@tanstack/react-query";

const MutationHandler = ({
  mutationFn,
  onSuccess,
  onError,
  onCancel,
  children,
}) => {
  const [success, setSuccess] = React.useState(null);
  const [error, setError] = React.useState(null);

  const mutation = useMutation({
    mutationFn: async (formData) => {
      return await mutationFn(formData);
    },
    onSuccess: (data) => {
      const successMessage =
        data?.message || data?.data?.message || "Operation successful!";
      setSuccess(successMessage);
      setError(null);

      setTimeout(() => {
        try {
          onSuccess?.();
          onCancel?.();
        } catch (err) {
          console.error("Callback failed:", err);
        }
      }, 750);
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.data?.errorMessage ||
        error?.response?.data?.message ||
        "Operation failed";
      setError(errorMessage);
      setSuccess(null);
      if (onError) onError(error);
    },
  });

  return (
    <div>
      {success && (
        <div
          className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-2 my-2"
          role="alert"
        >
          <p className="font-bold">{success}</p>
        </div>
      )}
      {error && (
        <div
          className="bg-red-100 border-t border-b border-red-500 text-red-700 px-4 py-2 my-2"
          role="alert"
        >
          <p className="font-bold">{error}</p>
        </div>
      )}

      {children(mutation)}
    </div>
  );
};

export default MutationHandler;
